// Remembers the last query string (table filters) of each page per browser
// tab, so going back to a list (e.g. "Torna indietro" from edit) restores
// its filters instead of resetting them.

const PREFIX = 'listSearch:';

const normalizePath = (pathname = '') => pathname.replace(/\/+$/, '') || '/';

const getStorage = () => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const saveListSearch = (pathname, search = '') => {
  const storage = getStorage();
  if (!storage) return;
  const key = PREFIX + normalizePath(pathname);
  const value = search.replace(/^\?/, '');
  try {
    if (value) {
      storage.setItem(key, value);
    } else {
      storage.removeItem(key);
    }
  } catch {
    // storage full or blocked: filters just won't be restored
  }
};

export const getSavedListSearch = (pathname) => {
  const storage = getStorage();
  if (!storage) return '';
  try {
    return storage.getItem(PREFIX + normalizePath(pathname)) || '';
  } catch {
    return '';
  }
};

export const clearSavedListSearches = () => {
  const storage = getStorage();
  if (!storage) return;
  try {
    Object.keys(storage)
      .filter((key) => key.startsWith(PREFIX))
      .forEach((key) => storage.removeItem(key));
  } catch {
    // ignore
  }
};
